import CollectionsPopup from './CollectionsPopup';

export default CollectionsPopup;



// WEBPACK FOOTER //
// ./src/components/CollectionsPopup/index.js